// ============================================================
// VCS.ChatPresence — Online-Status, Typing/Recording-Indikatoren
// ============================================================
window.VCS = window.VCS || {};

VCS.ChatPresence = class {

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {};
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    update(phone, online, lastSeen) {
        VCS.state.chatPresenceMap[phone] = {online, lastSeen};
        this.updateHeaderStatus();
        if (!online) {
            const prev = VCS.state.chatActivityMap[phone];
            if (prev?.timeout) {
                clearTimeout(prev.timeout);
            }
            delete VCS.state.chatActivityMap[phone];
        }
        if (VCS.nav?.isChatListVisible()) {
            VCS.chatMessages?.renderChatList?.();
        }
        if (!$('#tabContacts')[0]?.classList.contains('hidden')) {
            this.updateContactSubtitle(phone);
            this.updateOnlineDot(phone, online);
        }
    }

    async fetchPresence() {
        if (!VCS.state.chatChats.length || !VCS.state.chatMyPhone) {
            return;
        }
        const phones = VCS.state.chatChats.map(c => VCS.chat?.peerPhone?.(c)).filter(Boolean);
        if (phones.length === 0) {
            return;
        }
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/presence?phones=' + encodeURIComponent(phones.join(',')), {
                headers: VCS.chat?.authHeaders()
            });
            if (res.ok) {
                const data = await res.json();
                for (const [p, info] of Object.entries(data)) {
                    VCS.state.chatPresenceMap[p] = info;
                }
                this.updateHeaderStatus();
                VCS.chatMessages?.renderChatList?.();
            }
        } catch (e) {
            console.error('[chat] presence fetch error:', e);
        }
    }

    updateOnlineDot(phone, online) {
        const item = document.querySelector(`.chat-list-item[data-phone="${CSS.escape(phone)}"]`);
        if (!item) {
            return;
        }
        const avatar = item.querySelector('.chat-list-avatar');
        if (!avatar) {
            return;
        }
        const existingDot = avatar.querySelector('.chat-list-online-dot');
        if (online && !existingDot) {
            avatar.insertAdjacentHTML('beforeend', '<span class="chat-list-online-dot"></span>');
        } else if (!online && existingDot) {
            existingDot.remove();
        }
    }

    updateContactSubtitle(phone) {
        const item = document.querySelector(`.chat-list-item[data-phone="${CSS.escape(phone)}"]`);
        if (!item) {
            return;
        }
        const previewEl = item.querySelector('.chat-list-preview');
        if (!previewEl) {
            return;
        }

        const activity = VCS.state.chatActivityMap[phone];
        const presence = VCS.state.chatPresenceMap[phone];

        if (activity?.type === 'recording') {
            const recKey = activity.mode === 'video' ? 'chatRecordingVideo' : activity.mode === 'photo' ? 'chatRecordingPhoto' : 'chatRecording';
            const recIcon = activity.mode === 'video'
                ? '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" style="vertical-align:-1px"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>'
                : '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" style="vertical-align:-1px"><path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>';
            previewEl.innerHTML = `<span class="contact-activity contact-activity--recording">${recIcon} ${t(recKey)}</span>`;
        } else if (activity?.type === 'typing') {
            previewEl.innerHTML = `<span class="contact-activity contact-activity--typing">${t('chatTyping')}</span>`;
        } else if (presence?.online) {
            previewEl.innerHTML = `<span class="contact-activity contact-activity--online">${t('chatOnline')}</span>`;
        } else {
            previewEl.textContent = phone;
        }
    }

    updateHeaderStatus() {
        const statusEl = $('#chatDetailStatus')[0];
        if (!statusEl || !VCS.state.chatActiveChatId) {
            return;
        }
        const chat = VCS.state.chatChats.find(c => c.id === VCS.state.chatActiveChatId);
        if (!chat) {
            return;
        }

        // Gruppen-Chat: Members-Bar aktualisieren statt einzelnen Peer-Status
        if (VCS.state.chatActiveIsGroup) {
            statusEl.textContent = '';
            statusEl.className = 'chat-header-status';
            VCS.chatSetup?._loadGroupMembersBar?.(VCS.state.chatActiveChatId);
            return;
        }

        const peerPhone = VCS.chat?.peerPhone?.(chat);
        const presence = VCS.state.chatPresenceMap[peerPhone];
        if (!presence) {
            statusEl.textContent = '';
            statusEl.className = 'chat-header-status';
            return;
        }
        if (presence.online) {
            statusEl.textContent = t('chatOnline');
            statusEl.className = 'chat-header-status chat-header-status--online';
        } else if (presence.lastSeen) {
            const d = new Date(presence.lastSeen);
            const now = new Date();
            const timeStr = d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const yesterday = new Date(today.getTime() - 86400000);
            const seenDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            if (seenDay.getTime() === today.getTime()) {
                statusEl.textContent = t('chatLastSeen').replace('{0}', timeStr);
            } else if (seenDay.getTime() === yesterday.getTime()) {
                statusEl.textContent = t('chatLastSeenYesterday').replace('{0}', timeStr);
            } else {
                const dateStr = d.getDate().toString().padStart(2, '0') + '.' + (d.getMonth() + 1).toString().padStart(2, '0') + '.' + d.getFullYear();
                statusEl.textContent = t('chatLastSeenDate').replace('{0}', dateStr).replace('{1}', timeStr);
            }
            statusEl.className = 'chat-header-status';
        } else {
            statusEl.textContent = '';
            statusEl.className = 'chat-header-status';
        }
    }

    showTyping(phone) {
        const indicator = $('#chatTypingIndicator')[0];
        const text = $('#chatTypingText')[0];
        if (!indicator || !text) {
            return;
        }
        const recIndicator = $('#chatRecordingIndicator')[0];
        if (recIndicator && !recIndicator.classList.contains('hidden')) {
            return;
        }
        text.textContent = t('chatTyping');
        indicator.classList.remove('hidden');
        if (VCS.state.chatTypingHideTimeout) {
            clearTimeout(VCS.state.chatTypingHideTimeout);
        }
        VCS.state.chatTypingHideTimeout = setTimeout(() => {
            indicator.classList.add('hidden');
        }, 4000);
    }

    showRecordingIndicator(phone, mode) {
        const typingIndicator = $('#chatTypingIndicator')[0];
        if (typingIndicator) {
            typingIndicator.classList.add('hidden');
        }

        const indicator = $('#chatRecordingIndicator')[0];
        const text = $('#chatRecordingIndicatorText')[0];
        if (!indicator || !text) {
            return;
        }
        const recKey = mode === 'video' ? 'chatRecordingVideo' : mode === 'photo' ? 'chatRecordingPhoto' : 'chatRecording';
        text.textContent = t(recKey);
        indicator.classList.remove('hidden');
        if (VCS.state.chatRecordingIndicatorTimeout) {
            clearTimeout(VCS.state.chatRecordingIndicatorTimeout);
        }
        VCS.state.chatRecordingIndicatorTimeout = setTimeout(() => {
            indicator.classList.add('hidden');
        }, 5000);
    }

    setActivity(phone, type, mode) {
        const prev = VCS.state.chatActivityMap[phone];
        if (prev?.timeout) {
            clearTimeout(prev.timeout);
        }
        const duration = type === 'recording' ? 5000 : 4000;
        const entry = {
            type,
            timeout: setTimeout(() => {
                delete VCS.state.chatActivityMap[phone];
                this.updateContactSubtitle(phone);
            }, duration)
        };
        if (mode) entry.mode = mode;
        VCS.state.chatActivityMap[phone] = entry;
        this.updateContactSubtitle(phone);
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        // leer
    }
};
